import { AssertionError } from '../errors/ErrorTypes'

export const assertExists = <T>(input: T | null | undefined, message?: string, metadata?: object): T => {
  if (input === undefined || input === null) {
    throw new AssertionError(message ?? 'Expectation of non-null/undefined value violated', metadata)
  }
  return input
}
